import classNames from 'classnames'
import { TRANSLATION_KEYS } from 'legacy/lut/components/common/apolloSearch/components/apolloMatchesDialog/translations'
import { getFieldDiffStatus } from 'legacy/lut/components/widgets/public/partnerDuplicates/components/partnerDuplicatesContent/partnerDuplicatesRow/expandedRowContent/partnerDuplicatesDiff/helpers/getFieldDiffStatus'
import { useCallback } from 'react'

import { RenderWhen } from 'clickNgo/components/renderWhen'
import { IPartner, TPartnerDifference } from 'clickNgo/entities/partner/models'
import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './ApolloMatchesDiff.module.scss'

interface IProps {
  partner: IPartner
  difference: TPartnerDifference[]
  onPartialReplace?: (field: keyof IPartner, newValue: string, partner: IPartner) => void
}

export const ApolloMatchesDiff = ({ difference, onPartialReplace, partner }: IProps) => {
  const partialReplaceClick = useCallback(
    (field: keyof IPartner, newValue: string) => () => {
      if (onPartialReplace) {
        onPartialReplace(field, newValue, partner)
      }
    },
    [onPartialReplace, partner]
  )

  return (
    <table className={classNames(styles.table)}>
      <thead>
        <tr>
          <th colSpan={4} className={styles.title}>
            {/* Compare your result with company data */}
            <Translation text={'partner-apollo-compare-data'} span />
          </th>
        </tr>
        <tr className={styles.header}>
          <th>
            <Translation text={TRANSLATION_KEYS.tableColumns.subTable.field} span />
          </th>
          <th>
            <Translation text={TRANSLATION_KEYS.tableColumns.subTable.compared} span />
          </th>
          <th />
          <th>
            <Translation text={TRANSLATION_KEYS.tableColumns.subTable.original} span />
          </th>
          <th>
            <Translation text={TRANSLATION_KEYS.tableColumns.subTable.status} span />
          </th>
        </tr>
      </thead>
      <tbody>
        {difference.map((differenceData) => {
          const { isDifferent, isEmpty, field, originalValue, comparedValue } = differenceData
          const iconClassNames = styles[getFieldDiffStatus({ isDifferent, isEmpty })]
          const bodyRowClassName = styles[`row__${getFieldDiffStatus({ isDifferent, isEmpty })}`]

          return (
            <tr key={field} className={bodyRowClassName}>
              <th>
                <Translation text={field} span />
              </th>
              <td>{String(comparedValue)}</td>

              <td>
                <RenderWhen condition={isDifferent && !isEmpty && Boolean(onPartialReplace)}>
                  <i
                    className={classNames('kbase kbase-arrow-right', styles.arrow)}
                    onClick={partialReplaceClick(field, String(comparedValue))}
                  />
                </RenderWhen>
              </td>

              <td>{String(originalValue)}</td>
              <td className={styles.diff_icon}>
                <strong className={iconClassNames}>
                  {getFieldDiffStatus({ isDifferent, isEmpty })}
                </strong>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
